import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";

import { BindingOfferDialog } from "./binding-offer-dialog";

type BindingOfferMarketplaceOrderAllTradersDialogProps = {
  cropName: string;
  amount: string;
  quarter: string;
  postalCodeLabel: string;
  parameters?: string;
  unitPrice: string;
  isPending: boolean;
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
};

const BindingOfferMarketplaceOrderAllTradersDialog = ({
  postalCodeLabel,
  ...props
}: BindingOfferMarketplaceOrderAllTradersDialogProps) => {
  return (
    <BindingOfferDialog
      {...props}
      confirmLabel={<Trans>Odeslat poptávku</Trans>}
      introText={
        <Trans>
          Kupující tímto předkládá prodávajícímu závazný požadavek na nákup
          zboží za níže uvedených podmínek:
        </Trans>
      }
      legalConsentText={
        <Trans>
          Nakupující souhlasí s tím, že obsah kupní smlouvy se bude řídit
          obchodními podmínkami konkrétního obchodníka, který poptávku přijme.
          VOP jsou součástí kupní smlouvy.
        </Trans>
      }
      legalNoticeText={
        <Trans>
          Kupující bere na vědomí, že prodávající nemá povinnost tento návrh
          akceptovat. Kupní smlouva vzniká konfirmací tohoto závazného návrhu ze
          strany prodávajícího.
        </Trans>
      }
      parity={t`CPT - ${postalCodeLabel}`}
      title={<Trans>Podmínky pro vytvoření závazné poptávky</Trans>}
      tradingHoursText={
        <Trans>
          Prodávající přijímá závazné objednávky v obvyklých obchodních
          hodinách.
        </Trans>
      }
    />
  );
};

export { BindingOfferMarketplaceOrderAllTradersDialog };
